import React from 'react';
import { useTranslations } from 'use-intl';
import { toNamespaceKey, toTranslationKey } from '@/utils/translations';
import InputField from '@/UIlibrary/InputField/InputField';
import MoneyInputField from '@/UIlibrary/MoneyInputField/MoneyInputField';
import Select from '@/UIlibrary/Select/Select';
import { Typography } from '@/UIlibrary/Typography/Typography';

interface QuestionnaireEditableInputProps {
	title: string;
	value: string | number | null | undefined;
	onChange: (value: string | number | null) => void;
	type?: 'text' | 'number' | 'date' | 'money';
	isSelect?: boolean;
	options?: { label: string; value: string }[];
	error?: string;
	translationsSource?: string;
}

const QuestionnaireEditableInput: React.FC<QuestionnaireEditableInputProps> = ({
	title,
	value,
	onChange,
	type = 'text',
	isSelect = false,
	options,
	error,
	translationsSource = 'MicrocreditRequestQuestionnaire'
}) => {
	const t = useTranslations(toNamespaceKey(translationsSource));

	const handleChange = (newValue: string | number | null) => {
		onChange(newValue);
	};

	const getInputComponent = () => {
		if (isSelect && options) {
			return (
				<Select
					name={title}
					value={value as string}
					options={options}
					onChange={(e) => handleChange(e.target.value)}
					errorMessage={error}
				/>
			);
		}
		if (type === 'money') {
			return (
				<MoneyInputField
					name={title}
					value={value as string}
					onChange={(value) => handleChange(value)}
					error={!!error}
					hint={error}
					size="xsmall"
				/>
			);
		}
		return (
			<InputField
				name={title}
				size="xsmall"
				type={type}
				value={value as string}
				onChange={(e) => handleChange(e.target.value)}
				error={!!error}
				hint={error}
			/>
		);
	};

	return (
		<div className="grid grid-cols-2 gap-2">
			<Typography size="sm" weight="medium">
				{t(toTranslationKey(title))}:
			</Typography>
			{getInputComponent()}
		</div>
	);
};

export default QuestionnaireEditableInput;
